var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.publicUrl
        ? _c(
            "div",
            {
              staticClass: "col col-12 image-containder",
              on: {
                click: function($event) {
                  return _vm.openPrompImage()
                }
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.dimention.height) +
                  " x " +
                  _vm._s(_vm.dimention.width) +
                  " px "
              ),
              _c("img", {
                staticClass: "preview-image",
                attrs: { src: _vm.publicUrl }
              })
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "col col-12" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: { readonly: "" },
          domProps: { value: _vm.value }
        })
      ]),
      _c("div", { staticClass: "col-md-2 mt-1" }, [
        _c(
          "div",
          { staticClass: "btn-group" },
          [
            _c("DownloadS3File", {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: "Descargar",
                  expression: "'Descargar'"
                }
              ],
              attrs: {
                path: _vm.value,
                name: _vm.param + ".png",
                force: "si",
                "style-class": "btn btn-outline-secondary"
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function(props) {
                    return [
                      !props.downloading
                        ? _c("span", { staticClass: "material-icons" }, [
                            _vm._v("cloud_download")
                          ])
                        : _vm._e(),
                      props.downloading
                        ? _c("b-spinner", {
                            attrs: { variant: "primary", size: "18" }
                          })
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm.hasPermisionSave
              ? _c("UploadFileToS3", {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip",
                      value: "Cargar",
                      expression: "'Cargar'"
                    }
                  ],
                  attrs: { "upload-to": _vm.attachmentUrl },
                  on: { input: _vm.uploadLocalFile },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "button",
                        fn: function(props) {
                          return [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary",
                                attrs: { disabled: props.progress.enabled }
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("cloud_upload")
                                ])
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3294952022
                  )
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "vs-prompt",
        {
          attrs: {
            "accept-text": "Modificar imagen",
            "cancel-text": "Me arrepentí",
            title: "Nueva imagen",
            "is-valid": _vm.validarImagenVacia,
            active: _vm.promtpImage,
            id: "prompt-image"
          },
          on: {
            accept: _vm.uploadImagen,
            close: _vm.closePromptImage,
            "update:active": function($event) {
              _vm.promtpImage = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "cropper-image-container" },
            [
              _c("cropper", {
                ref: "cropper",
                attrs: {
                  classname: "cropper",
                  src: _vm.previewImageCroper,
                  stencilProps: { previewClassname: "preview" },
                  stencilComponent: _vm.$options.components.CircleStencil
                }
              }),
              _c("div", { staticClass: "button-wrapper" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "button-imagen vs-button-primary vs-button-border",
                    on: {
                      click: function($event) {
                        return _vm.$refs.imagen.click()
                      }
                    }
                  },
                  [
                    _c("input", {
                      ref: "imagen",
                      attrs: { type: "file", accept: "image/*" },
                      on: {
                        change: function($event) {
                          return _vm.selectNewImagen($event)
                        }
                      }
                    }),
                    _vm._v(" Seleccionar imagen ")
                  ]
                )
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }